var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightFrom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 4.00002H3.99996V12H2.66663V4.00002ZM5.33329 8.66669H11.0573L8.19529 11.5287L9.13796 12.4714L13.6093 8.00002L9.13796 3.52869L8.19529 4.47135L11.0573 7.33335H5.33329V8.66669Z",
    fill: "#9499A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightFrom);
export default __webpack_public_path__ + "static/media/arrow-right-from.366494282f520f2c6467f59411e3673e.svg";
export { ForwardRef as ReactComponent };